import React from 'react';
import CustomModal from './index';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const ModalSuccess = ({ title, close, children, icon = false, size = 'lg' }) => {
  const buttons = [
    {
      title: 'Aceptar',
      className: 'btn btn-danger text-center',
      action: close,
    },
  ];

  return (
    <CustomModal title={title} show={true} close={close} buttons={buttons} size={size}>
      {icon && (
        <div className='d-flex justify-content-center pt-3'>
          <FontAwesomeIcon
            icon={faCheckCircle}
            className='text-success'
            style={{ transform: 'scale(2)' }}
          />
        </div>
      )}
      <div className='d-flex justify-content-center p-4 text-center'>{children}</div>
    </CustomModal>
  );
};

ModalSuccess.proptypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default ModalSuccess;
